<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Welcome to the program</h1>
        </template>

        <p class="">For every user who comes via your unique ambassador link, and becomes a paying customer, <strong>we pay you 30% of the recurring revenue</strong>.</p>
        
        <p class="mt-6">Not credits. Not gift cards. 💰<strong>Cold hard cash.</strong></p>
        
        <p class="mt-6">Either via PayPal or bank transfers. 🌏<strong>Anywhere in the world.</strong></p>

        <template v-slot:footer>
            <progressable-button 
                type="submit"
                class="py-2 px-4 rounded-md bg-primary text-white"
                :state="'Generating...'"
                :loading="generating"
                @click.native="generate">
                Generate my Ambassador Link
            </progressable-button>
        </template>
    </modal-component>
</template>

<script>
import ProgressableButton from '../ProgressableButton.vue';
export default {
  components: { ProgressableButton },
    data() {
        return {
            generating: false,
        }
    },
    methods: {
        generate() {
            this.generating = true;
            axios.post('/api/ambassador/code')
                .then(response => {
                    this.$emit('resolve')
                })
                .catch(err => console.error)
                .finally(() => {
                    this.generating = false;
                });
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>